import apiClient from './authService';

export const leaseService = {
  getAll: async () => {
    const response = await apiClient.get('/api/leases');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/api/leases/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/api/leases', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/api/leases/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/api/leases/${id}`);
    return response.data;
  }
};
